export default function ToothIcon({ className = "w-4 h-4", strokeWidth = 1.6, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* Tooth outline: rounded crown with two roots, gentle waist */}
      <path d="M8.5 2.6c-2.7 0.4 -4.4 2.5 -4.4 5.1 0 1.6 0.4 2.6 0.7 4 0.4 1.7 0.2 3.3 0.1 5.2 -0.1 1.7 0.1 4.4 1.5 4.6 1.5 0.2 1.9 -2.4 2.4 -4.7 0.4 -1.8 0.7 -3.3 1.7 -3.4 1.1 -0.2 1.6 1.1 2.1 3.1 0.6 2.4 1 5.2 2.5 5 1.5 -0.2 1.5 -3 1.4 -4.7 -0.1 -1.9 -0.4 -3.5 0 -5.2 0.3 -1.4 0.7 -2.4 0.7 -4 0 -2.6 -1.7 -4.7 -4.4 -5.1 -1.4 -0.2 -2.7 0.4 -2.7 0.4 s -0.2 0.6 -1 0.6 -1 -0.6 -1 -0.6 s -0.2 -0.6 -1.6 -0.3 z" />
      {/* Subtle highlight for 3D feel */}
      <path d="M9.5 6c0.6 -0.6 1.4 -0.9 2.2 -0.9" opacity="0.6" />
    </svg>
  );
}
